import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  tags: string[];
  status: string;
  categoryName?: string;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  tags,
  status,
  categoryName,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={`${title} - 韩国漫画在线阅读`}
          title={`${title} - 免费韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span
            className={`text-xs font-label px-2 py-0.5 rounded-full font-medium ${
              status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1.5">
            <i className="ri-star-fill text-xs text-accent-500 w-3 h-3 flex items-center justify-center"></i>
            <span className="text-xs text-background-50 font-label font-semibold">{rating}</span>
            <span className="text-xs text-background-300 ml-auto">{formatViews(views)} 阅读</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors font-heading">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">
          {author}
          {categoryName && (
            <span className="ml-2 text-foreground-400">{categoryName}</span>
          )}
        </p>
        <div className="flex flex-wrap items-center gap-1.5 mt-2">
          {tags.slice(0, 3).map(tag => (
            <span
              key={tag}
              className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-800 font-label"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}